export default "__VITE_ASSET__htD$qBM4__"